<template>
	<div>
		<buttonlist
				@help="help"
				@opentable="opentable"
				@search="search"
				@reflash="reflash"
				@exps="exp"
				ref="SetBtn"
		></buttonlist>
		<div style="margin-top: 2px">
			<el-button type="primary" size="mini" @click="monthCheck(0)" :disabled="!btn.monthcheck">{{$t('getapi[1273]')}}</el-button>
		</div>
		<wTable
				id="xpane-0"
				:data="dataSet"
				:loading="loading"
				queryData="SalTruInfoView1"
				:filter_thousandth="['Sale_Qty','Inv_Qty','Sal_Base_Net_Unit','Sal_Base_Net_Amount','Invoice_Qty','Invoice_Local_Net_Unit',
				'Invoice_Local_Net_Amount','Invoice_Base_Net_Unit','Invoice_Base_Net_Amount','Issue_Material_Unit','Issue_Man_Unit',
				'Issue_Charge_Unit','Issue_Material_Amount','Issue_Man_Amount','Issue_Charge_Amount']"
				:header="tableHeader"
				:option="tableOption"
				ref="singleTable"
				:checkflg="false"
		></wTable>
		<!--<el-table
				:data="dataSet"
				v-loading="loading"
				:highlight-current-row="true"
				show-overflow-tooltip="true"
				border
				stripe
				size="mini"
				:height="tableHeight  - reduceTableHeight"
				header-row-class-name="headerclass"
				style="width: 100%; margin-top:0px"
				:header-cell-style="$limits.headerClass"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Invoice_Audit_Year" :label="$t('getapi[7733]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Invoice_Audit_Month" :label="$t('getapi[7734]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Order_No" :label="$t('getapi[2292]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Finance_Date" :label="$t('getapi[6489]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Line_No" :label="$t('getapi[1425]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="part_code" :label="$t('getapi[112]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="part_version" :label="$t('getapi[149]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="category_first_name" :label="$t('getapi[169]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="category_second_name" :label="$t('getapi[170]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="category_third_name" :label="$t('getapi[171]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="item_code" :label="$t('getapi[3437]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="part_name" :label="$t('getapi[116]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="part_model" :label="$t('getapi[124]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Sale_Measure_Unit" :label="$t('getapi[2658]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Sale_Qty" :label="$t('getapi[7739]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Inv_Measure_Unit" :label="$t('getapi[1340]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Inv_Qty" :label="$t('getapi[7740]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Sal_Base_Net_Unit" :label="$t('getapi[7954]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Sal_Base_Net_Amount" :label="$t('getapi[7955]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Invoice_No" :label="$t('getapi[2992]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Invoice_Status" :label="$t('getapi[3694]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Invoice_Code" :label="$t('getapi[3681]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Invoice_Create_Date" :label="$t('getapi[7742]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Invoice_Audit_Date" :label="$t('getapi[3892]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Invoice_Qty" :label="$t('getapi[7743]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Invoice_Local_Net_Unit" :label="$t('getapi[7744]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Invoice_Local_Net_Amount" :label="$t('getapi[5124]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Currency_Exchange_Rate" :label="$t('getapi[7745]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Invoice_Base_Net_Unit" :label="$t('getapi[7956]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Invoice_Base_Net_Amount" :label="$t('getapi[7957]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Customer_Code" :label="$t('getapi[2610]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Customer_Name" :label="$t('getapi[3892]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Issue_Material_Unit" :label="$t('getapi[7750]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Issue_Man_Unit" :label="$t('getapi[7751]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Issue_Charge_Unit" :label="$t('getapi[7752]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Issue_Material_Amount" :label="$t('getapi[7585]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Issue_Man_Amount" :label="$t('getapi[7586]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Issue_Charge_Amount" :label="$t('getapi[7587]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="CO_Code" :label="$t('getapi[2291]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Currency_Code" :label="$t('getapi[3108]')"></el-table-column>
			<el-table-column show-overflow-tooltip sortable prop="Send_Status" :label="$t('getapi[4522]')"></el-table-column>
		</el-table>-->
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[100, 200, 300, 400]"
						:page-size="pageSize"
						:pager-count="5"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<serce :isVisible="isVisible" queryData="SalTruInfoView1" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[7953]')" queryData="SalTruInfoView1" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>

		<el-dialog v-dialogDrag :title="$t('getapi[1273]')" :visible.sync="monthCheckVisible" width="30%">
			<table>
				<tr>
					<td style="width:60px">{{ $t("getapi[1974]") }}</td>
					<td style="width:150px;">
						<el-select
								filterable
								v-model="year"
								size="mini"
								style="margin-righ:20px"
						>
							<el-option
									v-for="item in yearList"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							></el-option>
						</el-select>
					</td>
					<td style="width:60px">{{ $t("getapi[1975]") }}</td>
					<td style="width:150px;">
						<el-select
								filterable
								v-model="month"
								size="mini"
								style="margin-righ:20px"
								@change="getMonthData()"
						>
							<el-option
									v-for="item in monthList"
									:key="item.value"
									:label="item.label"
									:value="item.value"
							></el-option>
						</el-select>
					</td>
				</tr>
			</table>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="monthCheckVisible = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="small" type="primary" @click="confirmMonthCheck(0)">{{$t('getapi[2051]')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import {Loading} from 'element-ui';
    export default {
        name:'sendproductinfo',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('sendproductinfo'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight3,
                monthList: [
                    {
                        value: 1,
                        label: 1,
                    },
                    {
                        value: 2,
                        label: 2,
                    },
                    {
                        value: 3,
                        label: 3,
                    },
                    {
                        value: 4,
                        label: 4,
                    },
                    {
                        value: 5,
                        label: 5,
                    },
                    {
                        value: 6,
                        label: 6,
                    },
                    {
                        value: 7,
                        label: 7,
                    },
                    {
                        value: 8,
                        label: 8,
                    },
                    {
                        value: 9,
                        label: 9,
                    },
                    {
                        value: 10,
                        label: 10,
                    },
                    {
                        value: 11,
                        label: 11,
                    },
                    {
                        value: 12,
                        label: 12,
                    },
                ],
                yearList: [],
				month:'',
				yearL:'',
                btn:{
                    monthcheck: true
				},
                monthCheckVisible: false,//月结弹窗
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            let thisyear = new Date().getFullYear();
            for (let i = 0; i < 5; i++) {
                let obj = {
                    value: thisyear - i,
                    label: thisyear - i,
                };
                that.yearList.push(obj);
            }
            that.year = thisyear;
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('SalTruInfoView1', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            authority() {
                let that = this;
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                if (that.$limits.authority('plv4', 551, 1) == 1) {
                    that.btn.monthcheck = true;
                } else {
                    that.btn.monthcheck = false;
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('sendproductinfo',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'SalTruInfoView1');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Sal/Tru/Sal_TruSendProductView', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                    that.loading = false;
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            //导出·
            exp() {
                let that = this;
                that.loading = true;
                let pm = {
                    query_Condition: '',
                    query_field_type: '',
                    query_field_name: '',
                    row_sign: '',
                    query_sort: ''
                };
                let parm = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: []
                };
                that.queryData.forEach(item => {
                    pm = {
                        row_sign: item.row_sign,
                        query_Condition: item.query_Condition,
                        query_sort: item.query_sort,
                        query_field_type: item.Query_Field_Type,
                        query_field_name: item.Query_Field_Name
                    };
                    parm.Param.push(pm);
                });
                that.$http.urlpost('/Sal/Tru/Sal_TruSendProductViewExportToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                    that.loading = false;
                });
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "SalTruInfoView1",
                    fromname: that.$t('getapi[7953]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)*/
            },
            monthCheck(val) {
                let that = this
				that.monthCheckVisible = true
            },
			confirmMonthCheck(val){
                let that = this
                if (that.month == '' || that.year == '') {
                    that.$message.warning(that.$t('getapi[8783]'))//'年月不能为空'
                    return
                }
                let parm = {
                    TYear: that.year,
                    Month: that.month,
                    Confirmflag: val
                }
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Sal/Tru/SalTruSendProductMonthCheck', parm, function (res) {
                    if (res.Success == 1) {
                        that.monthCheckVisible = false
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    } else if (res.Success == 2) {
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.confirmMonthCheck(res.Success)
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                    loadingInstance.close()
                });
			},
        }
    };
</script>

<style scoped lang="less">
	table {
		border-collapse: separate;
		border-spacing: 0px 5px;
		td {
			padding-left: 3px;
			white-space: pre;
		}
	}
</style>
